import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48483ea2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navigation pc-navigation"
};
const _hoisted_2 = {
  key: 0,
  class: "navigation-right-icon pc-navigation-right-icon",
  src: "https://img2.qiuwenxinli.com/official-website/header-menu-close.png"
};
const _hoisted_3 = {
  key: 1,
  class: "navigation-right-icon pc-navigation-right-icon",
  src: "https://img2.qiuwenxinli.com/official-website/header-menu-more.png"
};
import router from "@/router";
export default /*#__PURE__*/_defineComponent({
  __name: 'my-header',
  props: {
    isShowMenu: {
      type: Boolean,
      required: true
    }
  },
  emits: ["clickShowMenu", "redirectToIndex"],
  setup(__props, {
    emit: emits
  }) {
    function clickShowMenu() {
      emits("clickShowMenu");
    }
    function redirectToIndex() {
      if (router.currentRoute.value.name != "index") {
        router.replace({
          path: "/"
        });
        emits("redirectToIndex");
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        class: "navigation-header-logo pc-navigation-header-logo",
        src: "https://img2.qiuwenxinli.com/official-website/header-logo.png",
        onClick: redirectToIndex
      }), _createElementVNode("div", {
        class: "navigation-right pc-navigation-right",
        onClick: clickShowMenu
      }, [__props.isShowMenu ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), !__props.isShowMenu ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)])]);
    };
  }
});